import { MetaService } from 'app/services/meta.service';
import { Component } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { FragmentService } from '../../services/fragment.service';

@Component({
    selector: 'app-learning-page',
    templateUrl: './learning.component.html',
    standalone: false
})
export class LearningPageComponent extends BaseComponent {
  constructor(
    public fragmentService: FragmentService,
    public metaService: MetaService
  ) {
    super(fragmentService, metaService);
  }
}
